<template>
    <div id="page_03" class="page">
        <div class="content">
            <div class="content_area">
                <div class="item item_left">
                    <img src="@/assets/img/img_page_03_01.png" />
                </div>
                <div class="item item_right">
                    <p style="font-size:1rem;font-weight:bold;line-height:1.4rem;">
                        100여개 이상의 국내외 브랜드
                    </p>
                    <p style="margin-top:1.5rem;">
                        슈프림, 팔라스, 꼼데가르송, 베이프, 나이키, 아디다스 오리지널,<br/>
                        이지부스트, 벤 데이비스, 커버낫, 어반디타입, 마크곤잘레스,<br/>
                        낫포너드, 아조바이아조, 비디알, 알톤, 엑스사키, 나인옥토퍼스<br/>
                        그 외 다수 스트릿 브랜드<br/>
                    </p>
                </div>
                <div class="clear"></div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    nane: "Page03"    
}
</script>

<style scoped>
    .content{padding-top:4.86rem;padding-bottom:4.876rem;}
    .item>img{width:11.04rem;height:auto;}
    .item>p{font-size:0.5rem;text-align:right;}
    .item_right{margin-left:2.76rem;}

    @media (max-width:720px) {
        .item_right{margin:0;margin-top:2rem;}
        .item>p{font-size:0.7rem;text-align: center;}
    }    
</style>

